import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Register controllers automatically from this directory
const controllers = import.meta.glob("./**/*_controller.js", { eager: true })
for (const path in controllers) {
  const module = controllers[path]
  const name = path
    .replace(/^\.\//, "")
    .replace(/_controller\.js$/, "")
    .replace(/\//g, "--")
    .replace(/_/g, "-")
  application.register(name, module.default)
}
